import { render, staticRenderFns } from "./StoreIndexPage.vue?vue&type=template&id=161513d5&scoped=true&"
import script from "./StoreIndexPage.vue?vue&type=script&lang=js&"
export * from "./StoreIndexPage.vue?vue&type=script&lang=js&"
import style0 from "./StoreIndexPage.vue?vue&type=style&index=0&id=161513d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161513d5",
  null
  
)

export default component.exports